export default __webpack_public_path__ + "static/blob-41-9a1dcf944fa379fbdf808c5cbe08878d.svg";